import TokenSuggest from './TokenSuggest';

export default TokenSuggest;



// WEBPACK FOOTER //
// ./src/components/TokenSuggest/index.js